module.exports = __webpack_public_path__ + "img/SKILLS.4862204c.svg";